import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';

import { useEditItemsContext } from '../context';
import messages from '../messages';

const SaveButton = () => {
  const { items, save, isSaving } = useEditItemsContext();

  const onSave = useCallback(async () => {
    await save(items);
  }, [save, items]);

  return (
    <Button disabled={isSaving} onClick={onSave} theme='primary'>
      <FormattedMessage {...messages.saveButton} />
    </Button>
  );
};

export default SaveButton;
